<div class='w-[150px] md:w-[300px] transition-all duration-300 ease-in-out'>
    <img src='/logo.png' alt='CondoGenius Logo' />
</div>
